module.exports = __webpack_public_path__ + "img/tableta efervecente o dispersable.d838fccc.png";